import { render, staticRenderFns } from "./ExternalIncomeForm.vue?vue&type=template&id=7a1da3ea&scoped=true&"
import script from "./ExternalIncomeForm.vue?vue&type=script&lang=ts&"
export * from "./ExternalIncomeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1da3ea",
  null
  
)

export default component.exports